import { RouteRecordName } from 'vue-router'

import { links, SettingsNames } from '@/widgets/sidebar'

export const getEnabledSubLink = (name: RouteRecordName | null | undefined): string | undefined => {
  if (!name) return
  const link = links.get(name as SettingsNames)
  if (!link) return
  const subLinks = link.subLinks
  if (!subLinks || !subLinks.length) return
  for (const subLink of subLinks) {
    if (subLink.isFeatureEnabled.value) {
      return subLink.name
    }
  }
  return undefined
}
